import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notice", "acknowledgement"]

  connect() {
    this.refreshListener = this.refresh.bind(this)
    this.element.addEventListener("change", this.refreshListener)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener("change", this.refreshListener)
  }

  refresh() {
    const platform = this.element.querySelector('[name="campaign[platform]"]').value
    const kind = this.element.querySelector('[name="campaign[kind]"]').value
    const required = platform === "x" && kind !== "" && kind !== "follow"

    this.noticeTarget.hidden = !required
    this.acknowledgementTarget.disabled = !required
    this.acknowledgementTarget.required = required
    if (!required) this.acknowledgementTarget.checked = false
  }

  afterSubmit(event) {
    if (event.detail.success) this.acknowledgementTarget.checked = false
  }
}
